import { render, staticRenderFns } from "./EditorialBlackLists.vue?vue&type=template&id=24dfcb48&"
import script from "./EditorialBlackLists.vue?vue&type=script&lang=js&"
export * from "./EditorialBlackLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports